export default "__VITE_ASSET__dQOtFy17__"